export const MAKER_CHECKER_ROUTE_PATHS = {
  makerCheckerRequests: '/maker-checker/requests',
  makerCheckerConfigs: '/maker-checker/configs',
};

export const MAKER_CHECKER_API_PATHS = {
  requests: '/v1/api/platform/maker-checker/requests',
  configs: '/v1/api/platform/maker-checker/configs',
  metadataStatuses: '/v1/api/platform/maker-checker/metadata/statuses',
  metadataActions: '/v1/api/platform/maker-checker/metadata/actions',
  metadataRoles: '/v1/api/platform/maker-checker/metadata/roles',
  metadataPageSizes: '/v1/api/platform/maker-checker/metadata/page-sizes',
  metadataConfigPageSizes: '/v1/api/platform/maker-checker/metadata/config-page-sizes',
};

export const MAKER_CHECKER_QUERY_KEYS = {
  requests: ['maker-checker', 'requests'] as const,
  configs: ['maker-checker', 'configs'] as const,
  statuses: ['maker-checker', 'metadata', 'statuses'] as const,
  actions: ['maker-checker', 'metadata', 'actions'] as const,
  roles: ['maker-checker', 'metadata', 'roles'] as const,
  pageSizes: ['maker-checker', 'metadata', 'page-sizes'] as const,
  configPageSizes: ['maker-checker', 'metadata', 'config-page-sizes'] as const,
};
